module.exports = __webpack_public_path__ + "files/9087d26cfe2b357b7aac2d9b98e5fd43.png";